// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  settlementId: __t.u64().primaryKey().name("settlement_id"),
  cohesion: __t.f32(),
  readiness: __t.f32(),
  learning: __t.f32(),
  health: __t.f32(),
  order: __t.f32(),
  piety: __t.f32(),
  prosperity: __t.f32(),
  inflowAcc: __t.i64().name("inflow_acc"),
  lastTreasury: __t.i64().name("last_treasury"),
  updatedAt: __t.timestamp().name("updated_at"),
});
